import React from "react";
import useCurrentNotebook from "utilities/hooks/domain/notebooks/use-current-notebook";
import PageListItem from "./page-list-item";
import PageListHeader from "./page-list-header";
import { ViewModes } from "models/enumerations/view-modes/view-modes";
import usePageViewSettings from "./use-page-view-settings";
import placeholder from "assets/images/nfpa-link-glyph-grayscale.png";
import Image from "atoms/images/image";
import { t } from "utilities/localization-utils";

const CSS_BASE_CLASS = "c-pages";

const SharedPages = () => {
    const { currentNotebook } = useCurrentNotebook();
    const { viewMode } = usePageViewSettings();
    const viewSetting = viewMode === ViewModes.List ? " -list" : " -grid";
    const displayDefault = () => {
        return currentNotebook?.pages?.length === 0;
    };

    return (
        <div className={CSS_BASE_CLASS}>
            <PageListHeader />
            {displayDefault() && (
                <div className={`${CSS_BASE_CLASS}__default`}>
                    <Image
                        src={placeholder}
                        cssClassName={`${CSS_BASE_CLASS}__default__image`}
                    />
                    <span>{t("notebooks-shared-page-default")}</span>
                </div>
            )}
            <div className={`${CSS_BASE_CLASS}__page-list${viewSetting}`}>
                {currentNotebook?.pages?.map((page) => (
                    <PageListItem key={page.id} page={page} />
                ))}
            </div>
        </div>
    );
};

export default SharedPages;
